module.exports = __webpack_public_path__ + "static/media/logo_comacchio_trepponti.f02790b1.webp";